import { BodyContainer } from "App/styles";
import { MainTitle } from "components/MainTitle";
import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { DescriptionContainer } from "./styles";
import rulesUrl from "../../data/rules.md?url";

export default function Rules() {
  const [text, setText] = useState("");

  useEffect(() => {
    fetch(rulesUrl)
      .then((res) => res.text())
      .then((res) => setText(res))
      .catch((err) => console.log(err));
  });

  return (
    <BodyContainer>
      <MainTitle title="Reglamento" seoTitle="Reglamento" />
      <DescriptionContainer>
        <ReactMarkdown>{text}</ReactMarkdown>
      </DescriptionContainer>
    </BodyContainer>
  );
}
